import { CRUDServiceType } from '../common/service/CRUDServiceType';
import { CoreRestCRUDService } from '../coreCommon/common/rest/CoreRestCRUDService';
import { ISSOAuthService, ISSOStartLoginResponse } from './ISSOAuthService';

export type ISSOCompleteLoginRequest = {
  code: string;
  state?: string;
};

export type ISSOCompleteLoginResponse = {
  _userLogin: unknown;
  message: string;
};

export class RestSSOAuthService extends CoreRestCRUDService<any> implements ISSOAuthService {
  constructor(private type: CRUDServiceType) {
    super();
  }

  getEndpoint(): string {
    const url = this.config.url.api[this.type];
    return `${url}/auth/sso`;
  }

  async startLogin(providerId: string): Promise<ISSOStartLoginResponse> {
    return this.request()
      .url(`${this.getEndpoint()}/${encodeURIComponent(providerId)}/login`)
      .get()
      .json<ISSOStartLoginResponse>()
      .catch(this.handleError);
  }

  async completeLogin(providerId: string, payload: ISSOCompleteLoginRequest): Promise<ISSOCompleteLoginResponse> {
    return this.request()
      .url(`${this.getEndpoint()}/${encodeURIComponent(providerId)}/complete`)
      .post(payload)
      .json<ISSOCompleteLoginResponse>()
      .catch(this.handleError);
  }
}
